import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Services from 'components/Services/Services';
import PropTypes from 'prop-types';
import React from 'react';
import useServicesStyles from './assets/css/_services';
import { services } from './components/theme/dataset';
import AnimatedSection from 'components/AnimatedSection';

export default function Development(props) {
  const classes = useServicesStyles();
  const { description, title } = props;

  return (
    <div className={classes.root} id="services">
      <Container fixed>
        <Grid container spacing={0} direction="row" justifyContent="space-between" alignItems="center">
          <Grid item xs={12}>
            <div className={classes.serviceContent}>
              <AnimatedSection animation="fadeInDown" delay={0}>
                <Typography variant="h4" align="center" className={classes.sectionTitle}>
                  {title}
                </Typography>
              </AnimatedSection>
              <AnimatedSection animation="fadeInUp" delay={150}>
                <Typography component="p" align="" className={classes.sectionDescription}>
                  {description}
                </Typography>
              </AnimatedSection>
            </div>
          </Grid>
        </Grid>
        <AnimatedSection animation="scaleIn" delay={300}>
          <Services services={services} />
        </AnimatedSection>
      </Container>
    </div>
  );
}

Development.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};
